// var controller1 = new ScrollMagic.Controller();

// var scene1 = new ScrollMagic.Scene({
// 	duration: 500, triggerHook: 0.2
// })
// .setTween(".scroll_img1", {
// 	transform: 'rotate(60deg)'
// })
// .addTo(controller1);

var controller1 = new ScrollMagic.Controller();
var rotate_circle1 = TweenMax.to(".scroll_img1", 0.8, {rotation: 90, ease: Linear.easeNone});
var scene_h1 = new ScrollMagic.Scene({triggerElement: ".scroll_img1", duration: 1000}).setTween(rotate_circle1).addTo(controller1);


var controller2 = new ScrollMagic.Controller();
var rotate_circle2 = TweenMax.to(".scroll_img2", 0.5, {rotation: -120, ease: Linear.easeNone});
var scene_h2 = new ScrollMagic.Scene({triggerElement: ".scroll_img2", duration: 1000}).setTween(rotate_circle2).addTo(controller2);

var controller3 = new ScrollMagic.Controller();
var rotate_circle3 = TweenMax.to(".scroll_img3", 0.5, {rotation: -90, ease: Linear.easeNone});
var scene_h3 = new ScrollMagic.Scene({triggerElement: ".scroll_img3", duration: 1000}).setTween(rotate_circle3).addTo(controller3);

var controller4 = new ScrollMagic.Controller();
var rotate_circle4 = TweenMax.to(".scroll_img4", 0.5, {rotation: -120, ease: Linear.easeNone});
var scene_h4 = new ScrollMagic.Scene({triggerElement: ".scroll_img4", duration: 1000}).setTween(rotate_circle4).addTo(controller4);

var controller5 = new ScrollMagic.Controller();
var rotate_circle5 = TweenMax.to(".scroll_img5", 0.5, {rotation: -90, ease: Linear.easeNone});
var scene_h5 = new ScrollMagic.Scene({triggerElement: ".scroll_img5", duration: 1000}).setTween(rotate_circle5).addTo(controller5);

var controller6 = new ScrollMagic.Controller();
var rotate_circle6 = TweenMax.to(".scroll_img6", 0.5, {rotation: -120, ease: Linear.easeNone});
var scene_h6 = new ScrollMagic.Scene({triggerElement: ".scroll_img6", duration: 1000}).setTween(rotate_circle6).addTo(controller6);

var controller7 = new ScrollMagic.Controller();
var rotate_circle7 = TweenMax.to(".scroll_img7", 0.5, {rotation: -90, ease: Linear.easeNone});
var scene_h7 = new ScrollMagic.Scene({triggerElement: ".scroll_img7", duration: 1000}).setTween(rotate_circle7).addTo(controller7);

var controller8 = new ScrollMagic.Controller();
var rotate_circle8 = TweenMax.to(".scroll_img8", 0.5, {rotation: -120, ease: Linear.easeNone});
var scene_h8 = new ScrollMagic.Scene({triggerElement: ".scroll_img8", duration: 1000}).setTween(rotate_circle8).addTo(controller8);

var controller9 = new ScrollMagic.Controller();
var rotate_circle9 = TweenMax.to(".scroll_img9", 0.5, {rotation: -90, ease: Linear.easeNone});
var scene_h9 = new ScrollMagic.Scene({triggerElement: ".scroll_img9", duration: 1000}).setTween(rotate_circle9).addTo(controller9);
